import tutorialModule from './tutorial.module.js';

export default tutorialModule;
